/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AfregningService } from './services/afregning.service';
import { AnlaegService } from './services/anlaeg.service';
import { AreaBlacklistService } from './services/area-blacklist.service';
import { BetalerService } from './services/betaler.service';
import { DebugService } from './services/debug.service';
import { EgisService } from './services/egis.service';
import { ExcelService } from './services/excel.service';
import { FabrikatService } from './services/fabrikat.service';
import { FastprisaftaleService } from './services/fastprisaftale.service';
import { FejlDashboardService } from './services/fejl-dashboard.service';
import { ForaeldreloestAfregningsgrundlagService } from './services/foraeldreloest-afregningsgrundlag.service';
import { HenviserService } from './services/henviser.service';
import { HistoryService } from './services/history.service';
import { InstallatoerService } from './services/installatoer.service';
import { KreditnotaService } from './services/kreditnota.service';
import { KreditvurderingService } from './services/kreditvurdering.service';
import { KundeService } from './services/kunde.service';
import { ModelService } from './services/model.service';
import { OpfoelgningService } from './services/opfoelgning.service';
import { PartnerService } from './services/partner.service';
import { PartnerPostnummerService } from './services/partner-postnummer.service';
import { PartnerSubscriptionTypeService } from './services/partner-subscription-type.service';
import { PriceService } from './services/price.service';
import { ProduktService } from './services/produkt.service';
import { RabatKampagneService } from './services/rabat-kampagne.service';
import { ServiceAbonnementService } from './services/service-abonnement.service';
import { ServiceAftaleService } from './services/service-aftale.service';
import { ServiceaftaleConsumerService } from './services/serviceaftale-consumer.service';
import { ServiceordreService } from './services/serviceordre.service';
import { ServiceordreStateService } from './services/serviceordre-state.service';
import { ServiceRapportService } from './services/service-rapport.service';
import { SlutopgoerelseService } from './services/slutopgoerelse.service';
import { SystemStatusService } from './services/system-status.service';
import { TilvalgService } from './services/tilvalg.service';
import { VareService } from './services/vare.service';
import { VirksomhedService } from './services/virksomhed.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AfregningService,
    AnlaegService,
    AreaBlacklistService,
    BetalerService,
    DebugService,
    EgisService,
    ExcelService,
    FabrikatService,
    FastprisaftaleService,
    FejlDashboardService,
    ForaeldreloestAfregningsgrundlagService,
    HenviserService,
    HistoryService,
    InstallatoerService,
    KreditnotaService,
    KreditvurderingService,
    KundeService,
    ModelService,
    OpfoelgningService,
    PartnerService,
    PartnerPostnummerService,
    PartnerSubscriptionTypeService,
    PriceService,
    ProduktService,
    RabatKampagneService,
    ServiceAbonnementService,
    ServiceAftaleService,
    ServiceaftaleConsumerService,
    ServiceordreService,
    ServiceordreStateService,
    ServiceRapportService,
    SlutopgoerelseService,
    SystemStatusService,
    TilvalgService,
    VareService,
    VirksomhedService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
